/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  TestFeeCollectorShareRevenueCaller,
  TestFeeCollectorShareRevenueCallerInterface,
} from "../TestFeeCollectorShareRevenueCaller";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "feeCollector",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "RevenueShareCallbackInvalidSender",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "referrer",
        type: "address",
      },
      {
        components: [
          {
            internalType: "address",
            name: "receiver",
            type: "address",
          },
          {
            internalType: "uint96",
            name: "share",
            type: "uint96",
          },
        ],
        internalType: "struct RoyaltySharesLib.RoyaltyShare[]",
        name: "royaltyShares",
        type: "tuple[]",
      },
      {
        internalType: "bytes",
        name: "dataForCallback",
        type: "bytes",
      },
    ],
    name: "callShareRevenue",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "totalFee",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "dataForCallback",
        type: "bytes",
      },
    ],
    name: "revenueShareCallback",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "wasCalled",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

export class TestFeeCollectorShareRevenueCaller__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    feeCollector: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<TestFeeCollectorShareRevenueCaller> {
    return super.deploy(
      feeCollector,
      overrides || {}
    ) as Promise<TestFeeCollectorShareRevenueCaller>;
  }
  getDeployTransaction(
    feeCollector: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(feeCollector, overrides || {});
  }
  attach(address: string): TestFeeCollectorShareRevenueCaller {
    return super.attach(address) as TestFeeCollectorShareRevenueCaller;
  }
  connect(signer: Signer): TestFeeCollectorShareRevenueCaller__factory {
    return super.connect(signer) as TestFeeCollectorShareRevenueCaller__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): TestFeeCollectorShareRevenueCallerInterface {
    return new utils.Interface(
      _abi
    ) as TestFeeCollectorShareRevenueCallerInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): TestFeeCollectorShareRevenueCaller {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as TestFeeCollectorShareRevenueCaller;
  }
}
